import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useStoreImages, useAnalytics } from "@commons-monorepo/index";
import { useGlobalStyles } from "~/styles/context/global-styles-wrapper";
import { allowSpecialCharacters } from "../../utils/format";
import { mobileNavigatorUserAgents } from "../share-store/share-store.constants";
import { POPUP_DETAIL_PROFILE_EVENTS } from "./popup-detail-profile.events";
import { useOutletContext } from "@remix-run/react";
import {
  useAppNavigate,
  useAppSearchParams,
  getUrlCanonical,
} from "@commons-monorepo/index";
import { useShareStore } from "../share-store/share-store.hook";

export const usePopupDetailProfile = () => {
  const { storeMetadata, storeUseSubdomain, url } = useOutletContext<any>();
  const data = useOutletContext<any>();
  const [logEvent] = useAnalytics({ storeMetadata });
  const { t } = useTranslation();
  const { theme } = useGlobalStyles();
  const [queryParams, setQueryParams] = useAppSearchParams();
  const storeIsPrime = storeMetadata?.prime?.id !== undefined;
  const partnerNetwork = storeMetadata.userNetwork;
  const videoUrl = storeMetadata?.configuration.videoUrl;
  const navigate = useAppNavigate();
  const catalogueHomeUrl = storeUseSubdomain ? url : getUrlCanonical(data);
  const { partnerProfilePicture } = useStoreImages(data?.storeMetadata);
  const { sharedUrl } = useShareStore();
  const [showModalVideo, setShowModalVideo] = useState(false);

  const phone = useMemo(() => {
    return `${storeMetadata?.prefixPhone} ${storeMetadata?.phone}`;
  }, [storeMetadata]);

  const handleClosePopupDetail = (): void => {
    navigate("..", { replace: true });
  };

  const handleShare = (): void => {
    const text = `${t("share.details.store.title")} *${allowSpecialCharacters(
      storeMetadata?.enterpriseName || "",
    )}* ${t("share.details.store.link")}\n${sharedUrl()}`;
    if (mobileNavigatorUserAgents.test(navigator?.userAgent)) {
      if (navigator?.share) navigator?.share({ text });
    } else {
      queryParams.set("share", "");
      setQueryParams(queryParams);
    }
    logEvent(POPUP_DETAIL_PROFILE_EVENTS.SELECT_SHARE_STORE);
  };

  const triggerEvent = () => {
    logEvent(POPUP_DETAIL_PROFILE_EVENTS.SELECT_CONTACT_VENDOR, {
      source: "store_information",
    });
  };

  const handleShowVideo = () => {
    if (!showModalVideo) {
      logEvent(POPUP_DETAIL_PROFILE_EVENTS.SELECT_PLAY_STORE_VIDEO);
    }
    setShowModalVideo(!showModalVideo);
  };

  return {
    t,
    theme,
    storeMetadata,
    storeIsPrime,
    partnerNetwork,
    showModalVideo,
    videoUrl,
    phone,
    catalogueHomeUrl,
    partnerProfilePicture,
    handleClosePopupDetail,
    handleShare,
    triggerEvent,
    handleShowVideo,
  };
};
